import * as React from 'react';
const DermatiteDaPannolinoIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M139.13 93.15c.17 2.42.27 4.75.27 6.85-5.15 14.89-16.22 26.64-30.83 32.54M63.21 72.68c.47-3.18.82-5.22.82-5.22h71.94s.35 2.04.82 5.22M91.44 132.54c-14.61-5.9-25.68-17.65-30.83-32.54 0-2.1.1-4.43.27-6.85M108.56 132.54q-8.64 1.425-17.13 0"
      className="prefix__cls-2"
    />
    <path
      d="M139.39 100c-17.04 1.7-30 15.44-30.83 32.54M60.61 100c17.04 1.7 30 15.44 30.83 32.54"
      className="prefix__cls-2"
    />
    <path
      d="M138.71 88.01h-19.87c-1.88 0-3.43-1.54-3.43-3.43v-3.43c0-1.88 1.54-3.43 3.43-3.43h18.64L138.71 88ZM61.29 88.01h19.87c1.88 0 3.43-1.54 3.43-3.43v-3.43c0-1.88-1.54-3.43-3.43-3.43H62.52L61.29 88Z"
      className="prefix__cls-1"
    />
  </svg>
);
export default DermatiteDaPannolinoIcon;
